import React from 'react';
import { AnnouncementBar } from '../components/AnnouncementBar';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { TrustStrip } from '../components/TrustStrip';
import { FeaturedProducts } from '../components/FeaturedProducts';
import { Reviews } from '../components/Reviews';
import { WhyUs } from '../components/WhyUs';
import { GoalsGrid } from '../components/GoalsGrid';
import { ScienceSection } from '../components/ScienceSection';
import { LabTesting } from '../components/LabTesting';
import { FAQ } from '../components/FAQ';
import { Newsletter } from '../components/Newsletter';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen w-full bg-background" data-id="element-1333">
      <AnnouncementBar data-id="element-1334" />
      <Header data-id="element-1335" />
      <main data-id="element-1336">
        <Hero data-id="element-1337" />
        <TrustStrip data-id="element-1338" />
        <FeaturedProducts data-id="element-1339" />
        <Reviews data-id="element-1340" />
        <WhyUs data-id="element-1341" />
        <GoalsGrid data-id="element-1342" />
        <ScienceSection data-id="element-1343" />
        <LabTesting data-id="element-1344" />
        <FAQ data-id="element-1345" />
        <Newsletter data-id="element-1346" />
      </main>
      <Footer data-id="element-1347" />
    </div>;
}